import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { login } from '../api/auth';
import { useAuth } from '../context/AuthContext';

interface LoginForm {
  email: string;
  password: string;
}

const AdminLogin = () => {
  const { register, handleSubmit, formState } = useForm<LoginForm>({
    defaultValues: { email: '', password: '' }
  });
  const { login: setAuth } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (values: LoginForm) => {
    try {
      const data = await login(values.email, values.password);
      setAuth(data.admin, data.token);
      toast.success('Welcome back');
      navigate('/admin');
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Unable to login');
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full max-w-md space-y-5 rounded-3xl border border-slate-200 bg-white/90 p-8 shadow-2xl backdrop-blur dark:border-slate-800 dark:bg-slate-900/80"
      >
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-brand-500">Admin</p>
          <h1 className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">Sign in to manage docs</h1>
        </div>
        <label className="block text-sm font-medium text-slate-600 dark:text-slate-300">
          Email address
          <input
            {...register('email', { required: true })}
            type="email"
            className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 focus:border-brand-400 focus:outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-white"
          />
        </label>
        <label className="block text-sm font-medium text-slate-600 dark:text-slate-300">
          Password
          <input
            {...register('password', { required: true })}
            type="password"
            className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 focus:border-brand-400 focus:outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-white"
          />
        </label>
        <button
          type="submit"
          disabled={formState.isSubmitting}
          className="w-full rounded-2xl bg-brand-600 py-3 text-lg font-semibold text-white shadow-lg shadow-brand-500/30 transition hover:bg-brand-500 disabled:cursor-not-allowed disabled:bg-slate-400"
        >
          {formState.isSubmitting ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;

